export default function formatCurrency (input) {
    if (typeof input !== "number") {
        return input;
    }
    var formatter = new Intl.NumberFormat('en-gb', {
        style: 'currency',
        currency: 'GBP'
    });
    return formatter.format(input);
}